import update from 'immutability-helper'

export const noticeFetched = (state, action) => update(state, { notice: { $set: action.content !== '' ? action.content.split("\n") : null } })


// WEBPACK FOOTER //
// ./src/store/notices/reducerActions.js